import _ from 'lodash';
import React, { useMemo } from 'react';
import { AllocationBillableTypeFilter, AllocationBookingTypeFilter } from '~/components';

export default function AllocationFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      allocationBookingTypeId: isVisible('allocationBookingTypeId'),
      allocationBillableTypes: isVisible('allocationBillableTypes'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.allocationBookingTypeId && (
        <AllocationBookingTypeFilter
          value={filters.allocationBookingTypeId}
          onChange={({ target: { value } }) => onChange({ allocationBookingTypeId: value })}
        />
      )}

      {visible.allocationBillableTypes && (
        <AllocationBillableTypeFilter
          value={filters.allocationBillableTypes}
          onChange={({ target: { value } }) => onChange({ allocationBillableTypes: value })}
        />
      )}
    </>
  );
}
